"use client";

import {useLayoutEffect, useState, type ReactNode} from "react";
import {createPortal} from "react-dom";

/** Move the attachment with its turn without resetting workflow synchronization or an in-flight action. */
export default function WorkflowPanelPortal({host, children}: {host: HTMLDivElement | null; children: ReactNode}) {
   const [container, setContainer] = useState<HTMLDivElement | null>(null);
   useLayoutEffect(() => setContainer(document.createElement("div")), []);
   useLayoutEffect(() => {
      if (!host || !container) return;
      // React owns the portal's children; the transcript owns its empty host.
      host.appendChild(container);
      return () => container.remove();
   }, [host, container]);
   return container ? createPortal(children, container) : null;
}
